
const positiveInteger = /^[1-9]\d{0,12}$/  // 正整数
const integer12Decimal6 = /^\d{0,12}(\.\d{0,6})?$/  // 12位部包含复数的整数，6位小数
export const setRegexMap = {
  SG_B_STO_STORE_DISTRIBUTION_ITEM: {
    PLAN_DISTRIBUTION_QTY: positiveInteger, // 正整数
  },
  PS_C_SKU: {
    SHELF_LIFE: integer12Decimal6,  // 包含0的正整数，6位小数
  },
  SG_B_STO_OTHER_IN_ITEM:{
    QTY: positiveInteger
  }
};
export const setInputRegex = (props) => {
  const { tableName, colname } = props.item || {};
  // console.log(props, '==========props======', tableName, colname);
  if (setRegexMap[tableName] && setRegexMap[tableName][colname]) {

    const regex = setRegexMap[tableName][colname];
    props.item.props.regx = regex;
    props.regx = regex;
  }
};
